import { render, staticRenderFns } from "./PopulateShippingDimension.vue?vue&type=template&id=012ebf0a"
import script from "./PopulateShippingDimension.vue?vue&type=script&lang=js"
export * from "./PopulateShippingDimension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('012ebf0a')) {
      api.createRecord('012ebf0a', component.options)
    } else {
      api.reload('012ebf0a', component.options)
    }
    module.hot.accept("./PopulateShippingDimension.vue?vue&type=template&id=012ebf0a", function () {
      api.rerender('012ebf0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Categories/PopulateShippingDimension.vue"
export default component.exports